export const workspacesIdToInclude: String[] = [
  '68bf6e96-8ce8-49ea-b5dc-e695393db454',
  '815243ee-8eb0-41aa-898d-3eb79d12072d',
  '7e73f7d3-33c8-4078-b81b-f1924e0d0192',
  'aad6f0d0-4144-4447-b1cc-44003ac25fbc',
];

export const apisIdToExclude: String[] = ['9ac8ed5a-6ecc-436b-b069-2053cfb9df9b'];